module.exports = __webpack_public_path__ + "img/img4.c6c07d14.svg";